import * as Yup from 'yup';

export const createUserSchema = (uniqueId : string)=>{
    return Yup.object().shape({
        firstName: Yup.string().required('Required'),
        lastName: Yup.string().required('Required'),
        phoneNumber: Yup.string().when([], {
            is: () => (!uniqueId || uniqueId === "INVITECODE" || uniqueId === "PHONENUMBER"),
            then: Yup.string().matches(
                /^\+1[0-9]{10}$|^1[0-9]{10}$/,
                'Please enter a valid US phone number'
            ).required('Phone Number is required'),
            otherwise: Yup.string().notRequired()
        }),
        employeeId: Yup.string().when([], {
            is: () => uniqueId === "EMPLOYEEID",
            then: Yup.string().required('Employee ID is required'),
            otherwise: Yup.string().notRequired()
        }),
        backupEmail: Yup.string().when([], {
            is: () => uniqueId === "EMAILADDRESS",
            then: Yup.string().required('Email is required'),
            otherwise: Yup.string().notRequired()
        })
    });
}